module.exports = class Link extends Item
  build: ->
    @piece = P.a('a link')


